import { useState, useEffect } from "react";
import { FiFolder } from "react-icons/fi";
import Cookies from "js-cookie";
import { UploadPdfModal } from "./UploadPdfModal";
import { SignPdfModal } from "./SingPdfModal";
import signDoc from "../../../services/Documents/signDoc";
import RenderItemsTree from "./RenderItems";
import Top from "./Top";
import ItemsGrid from "./ItemsGrid";
import { useCreateTreeService } from "./services/TreeService";

export default function FoldersView({ caseId = null }) {
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentParentId, setCurrentParentId] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [isDocumentDownloading, setIsDocumentDownloading] = useState({
    documentId: "",
    isDownloading: false,
    isError: false,
  });
  const [isSignModalOpen, setIsSignModalOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [certFile, setCertFile] = useState(null);
  const [keyFile, setKeyFile] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [pdfName, setPdfName] = useState("");
  const [uploadStatus, setUploadStatus] = useState("");
  const [addStatus, setAddStatus] = useState("");
  const [userId, setUserId] = useState(null);

  const navigateToFolder = (folderId) => {
    setCurrentParentId(folderId);
    setSelectedItem(null);
  };

  const refreshCurrentFolder = () => {
    // Call updateTreeBranch with forceRefresh=true
    updateTreeBranch(currentParentId, true);
  };

  const [isLoadingTree, items, setItems, expandedFolderTree, _, updateTreeBranch, createToggleFolder] = useCreateTreeService(caseId);

  const toggleFolder = createToggleFolder(
    navigateToFolder,
    userId,
    currentParentId,
  );

  useEffect(() => {
    try {
      const userData = JSON.parse(Cookies.get("accountData") || "{}");
      if (userData._id) {
        setUserId(userData._id);
      }
    } catch (error) {
      console.error("Error getting user data from cookies:", error);
    }
    console.log("aaaaaapases");
    if (userId) {
      updateTreeBranch(currentParentId);
    }
    return () => {
      setItems([]);
    }
  }, [userId]);

  useEffect(() => {
    if (currentParentId === null) {
      setBreadcrumbs([{ id: null, name: "Inicio" }]);
      return;
    }

    const newBreadcrumbs = [];
    let parent = currentParentId;

    // Añadir el folder actual y sus padres
    while (parent !== null) {
      const folder = items.find((x) => x._id === parent);
      if (!folder) break;
      newBreadcrumbs.unshift({ id: folder._id, name: folder.folderName });
      parent = folder.parentFolderId;
    }

    // Añadir "Inicio" al principio
    newBreadcrumbs.unshift({ id: null, name: "Inicio" });
    setBreadcrumbs(newBreadcrumbs);
  }, [currentParentId, items]);

  const uploadDocument = () => {
    setIsUploadModalOpen(true);
    setPdf(null);
    setPdfName("");
    setAddStatus("");
  };

  const handleSignDocument = (document) => {
    setSelectedItem(document);
    setIsSignModalOpen(true);
    setCertFile(null);
    setKeyFile(null);
    setUploadStatus("");
  };

  const closeSignModal = () => {
    setIsSignModalOpen(false);
    setSelectedItem(null);
  };

  const getCurrentLevelItems = () =>
    items.filter((item) => {
      if (item.type === "folder") {
        return item.parentFolderId === currentParentId;
      } else {
        return item.folderId === currentParentId;
      }
    });

  return (
    <div className="flex h-full">
      {/* Navegación lateral de carpetas */}
      <div className="w-64 bg-white border-r p-4 h-full overflow-y-auto">
        <h2 className="text-lg font-medium mb-4">Explorador</h2>
        <div
          className={`flex items-center py-1 cursor-pointer hover:bg-gray-100 ${
            currentParentId === null ? "bg-blue-50" : ""
          }`}
          onClick={() => navigateToFolder(null)}
        >
          <FiFolder className="text-blue-500 mr-2" />
          <span className="font-medium">Carpetas principales</span>
        </div>

        <RenderItemsTree
          items={items}
          navigateToFolder={navigateToFolder}
          currentParentId={null}
          toggleFolder={toggleFolder}
          expandedFolderTree={expandedFolderTree}
          isLoadingTree={isLoadingTree}
          currentFolderId={currentParentId}
        />
      </div>

      {/* Contenido principal */}
      <div className="flex-1 p-6 bg-gray-50 h-full overflow-y-auto">
        <Top
          breadcrumbs={breadcrumbs}
          navigateToFolder={navigateToFolder}
          currentParentId={currentParentId}
          items={items}
          uploadDocument={uploadDocument}
          updateTreeBranch={refreshCurrentFolder}
          userId={userId}
          caseId={caseId}
          setSelectedItem={setSelectedItem}
        />

        {/* Lista de elementos */}
        <ItemsGrid
          getCurrentLevelItems={getCurrentLevelItems}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          toggleFolder={toggleFolder}
          isDocumentDownloading={isDocumentDownloading}
          handleSignDocument={handleSignDocument}
          setIsDocumentDownloading={setIsDocumentDownloading}
          userId={userId}
        />
      </div>

      {/* Modal para subir documentos */}
      {isUploadModalOpen && (
        <UploadPdfModal
          addStatus={addStatus}
          closeAddModal={() => setIsUploadModalOpen(false)}
          pdf={pdf}
          pdfName={pdfName}
          setAddStatus={setAddStatus}
          updateTreeBranch={refreshCurrentFolder}
          setPdf={setPdf}
          setPdfName={setPdfName}
          userId={userId}
          parentFolderId={currentParentId}
          caseId={caseId}
        />
      )}

      {/* Modal para firmar documentos */}
      {isSignModalOpen && selectedItem && (
        <SignPdfModal
          certFile={certFile}
          closeModal={closeSignModal}
          keyFile={keyFile}
          selectedDocument={selectedItem}
          setCertFile={setCertFile}
          updateTreeBranch={refreshCurrentFolder}
          setKeyFile={setKeyFile}
          setUploadStatus={setUploadStatus}
          signDoc={signDoc}
          uploadStatus={uploadStatus}
          userId={userId}
          parentFolderId={currentParentId}
          caseId={caseId}
        />
      )}
    </div>
  );
}
